import { Button, Typography, Result } from 'antd';
import { PauseCircleOutlined } from '@ant-design/icons';
import { useSimulation } from '../../context/SimulationContext';
import { WS_EVENTS } from '../../types/simulation.types';
import dayjs from 'dayjs';

interface PausedScreenProps {
  onRestart: () => void;
}

function PausedScreen({ onRestart }: PausedScreenProps) {
  const { resumeDeadline, simSessionId, socketRef, dispatch } = useSimulation();

  const handleContinue = () => {
    const socket = socketRef.current;
    if (!socket || !simSessionId) return;

    if (socket.connected) {
      socket.emit(WS_EVENTS.RECONNECT, { simSessionId });
    } else {
      socket.connect();
      socket.once('connect', () => {
        socket.emit(WS_EVENTS.RECONNECT, { simSessionId });
      });
    }
  };

  const deadlineText = resumeDeadline
    ? `You can continue until ${dayjs(resumeDeadline).format('MMM D, YYYY h:mm A')}`
    : 'You can continue this session.';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: 32,
      }}
    >
      <Result
        icon={<PauseCircleOutlined style={{ color: '#faad14' }} />}
        title="Session Paused"
        subTitle={
          <div>
            <Typography.Paragraph>
              Your session was paused due to inactivity.
            </Typography.Paragraph>
            <Typography.Text type="secondary">{deadlineText}</Typography.Text>
          </div>
        }
        extra={[
          <Button key="continue" type="primary" size="large" onClick={handleContinue}>
            Continue Session
          </Button>,
          <Button key="restart" size="large" onClick={onRestart}>
            Restart
          </Button>,
        ]}
      />
    </div>
  );
}

export default PausedScreen;
